import http from '@/shared/api/http'

export async function getAllUsers(includeDeleted = false) {
  return (await http.get(`admin/users?includeDeleted=${includeDeleted}`)).data
}

export async function getUserDetails(userId) {
  return (await http.get(`admin/users/${userId}`)).data
}

export async function toggleUserBlock(userId) {
  return (await http.post(`admin/users/${userId}/toggle-block`)).data
}

export async function refreshUserPermissions(userId) {
  return (await http.post(`admin/users/${userId}/refresh-permissions`)).data
}

export async function deleteUser(userId) {
  return (await http.delete(`admin/users/${userId}`)).data
}

export async function restoreUser(userId) {
  return (await http.post(`admin/users/${userId}/restore`)).data
}

export async function updateUserCompanyDetails(userId, data) {
  return (await http.patch(`admin/users/${userId}`, data)).data
}

export async function changeUserRole(userId, roleName) {
  return (await http.patch(`users/${userId}/role`, { roleName })).data
}